import React from 'react'
import LabelWithInfo from '../fields/elements/LabelWithInfo'

function CheckBox(props) {
    const {onChange, className, checked, label, info, disabled} = props;
    const labelOnClick = () => {
        return disabled ? (() => false)(): onChange();
    };

    return(
        <div className={className}>
            <input type="checkbox" checked={checked} disabled={disabled} onChange={onChange} />
            <LabelWithInfo className="form-check-label ms-2" name={label} info={info} onClick={labelOnClick} />
        </div>);
}

export default CheckBox;